/**
 * Savaş arka plan levhaları.
 *
 * Üretilmiş fonu olan sahneler görseli kullanır; olmayanlar `sahne.ts`
 * içindeki çizilmiş siluet fonuna düşer. Böylece eksik görsel oyunu
 * bozmaz, yalnızca daha sade görünür.
 */
export interface FonTanimi {
  kod: string
  ad: string
  /** public/ altındaki yol. null ise çizilmiş fona düşülür. */
  gorsel: string | null
}

export const FONLAR: Record<string, FonTanimi> = {
  otuken_ormani: {
    kod: 'otuken_ormani', ad: 'Ötüken Ormanı', gorsel: '/fon/otuken-ormani.webp',
  },
  dest_i_kipcak: {
    kod: 'dest_i_kipcak', ad: 'Deşt-i Kıpçak', gorsel: '/fon/dest-i-kipcak.webp',
  },
  altay: { kod: 'altay', ad: 'Altay Dağları', gorsel: null },
  taklamakan: { kod: 'taklamakan', ad: 'Taklamakan', gorsel: null },
  yedisu: { kod: 'yedisu', ad: 'Yedisu', gorsel: null },
  ergenekon: { kod: 'ergenekon', ad: 'Ergenekon', gorsel: null },
}

export function fonSec(kod: string): FonTanimi {
  return FONLAR[kod] ?? FONLAR.otuken_ormani!
}
